import api from './api';
import axios from 'axios';

// --- SUBIDA (Ya la tenías) ---
export const uploadFileToS3 = async (file, teamName, onProgress) => {
  // 1. Pedir URL y Headers al backend
  const presignResponse = await api.post('/files/presign-upload', {
    filename: file.name,
    contentType: file.type,
    folder: teamName
  });

  // Extraemos la URL y los Headers obligatorios
  const { uploadUrl, requiredHeaders } = presignResponse.data;

  console.log("Subiendo con headers:", requiredHeaders);

  // 2. Subir a S3 usando los headers que pidió el backend
  await axios.put(uploadUrl, file, {
    // Usamos requiredHeaders si existen, si no, fallback a solo Content-Type
    headers: requiredHeaders || { 'Content-Type': file.type },

    onUploadProgress: (progressEvent) => {
      if (onProgress) {
        const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        onProgress(percent);
      }
    }
  });
  return true;
};

// --- LISTAR ARCHIVOS (Nuevo) ---
// Asumimos que tienes un endpoint GET /files en tu API Gateway
export const listFiles = async (groups) => {
  try {
    // Enviamos los grupos como query param si el backend lo requiere para filtrar
    // O simplemente llamamos a GET /files y el backend filtra según el token del usuario
    const response = await api.get('/files', {
        params: { groups: groups.join(',') }
    });
    // Ajusta esto según si tu API devuelve { data: [...] } o directamente el array
    return response.data.files || response.data || [];
  } catch (error) {
    console.error("Error listando archivos:", error);
    throw error;
  }
};

// --- LISTAR CARPETAS (Nuevo) ---
// Si tu backend no tiene un endpoint específico para carpetas,
// podemos simularlo obteniendo todos los archivos y extrayendo los prefijos únicos.
export const listFoldersInBucket = async () => {
    try {
        const response = await api.get('/files/folders'); // Endpoint hipotético
        return response.data || [];
    } catch (error) {
        // Fallback: Si no tienes endpoint de carpetas, retorna lista vacía por ahora
        console.warn("Endpoint de carpetas no implementado aún en backend");
        return [];
    }
};

// --- DESCARGAR (Nuevo - Seguro) ---
export const downloadFile = async (file) => {
  try {
    // 1. Pedir URL firmada al backend (POST /presign-download según tu Insomnia)
    const response = await api.post('/files/presign-download', {
      bucket: process.env.REACT_APP_S3_BUCKET, // O deja que el backend decida el bucket
      key: file.key || file.name // Asegúrate de mandar la Key completa S3
    });

    const downloadUrl = response.data.downloadUrl || response.data;

    // 2. Forzar la descarga en el navegador
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', file.name); // Intenta forzar nombre
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error("Error descargando archivo:", error);
    alert("No se pudo descargar el archivo. Permiso denegado.");
  }
};

// --- ELIMINAR (Nuevo - Auditado) ---
export const deleteFile = async (file, onRefresh) => {
  if (!window.confirm(`¿Estás seguro de eliminar ${file.name}?`)) return;

  try {
    // DELETE /files según tu Insomnia
    await api.delete('/files', {
      data: {
        bucket: process.env.REACT_APP_S3_BUCKET,
        key: file.key || file.name
      }
    });

    if (onRefresh) onRefresh(); // Recargar la lista
  } catch (error) {
    console.error("Error eliminando archivo:", error);
    alert("Error al eliminar. Verifica tus permisos.");
  }
};
